import './style/blockquote.scss';
